

















import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// The base for every input component
import InputBase from './Base.vue';

@Component
export default class InputNumber extends InputBase<number> {

    @Prop({ type: Number, default: 0 })
    private min!: number;

    @Prop({ type: Number })
    private max!: number;

    @Prop({ type: Number, default: 1 })
    private step!: number;

}
